import Vue from 'vue'
import Router from 'vue-router'
//避免导航冗余
const routerPush = Router.prototype.push
Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)
export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'index',
      component: resolve => (require(["@/components/index"], resolve)),
      redirect: "/home",
      children: [
        {
          path: "/home",
          name: "home",
          component: resolve => (require(['@/components/home'], resolve)),
          meta: {
            active: "首页"
          }
        },
        {
          path: "/education",
          name: 'education',
          component: resolve => (require(['@/components/education'], resolve)),
          meta: {
            title: "投资者教育"
          }
        },
        {
          path: "/education_m",
          name: 'education_m',
          component: resolve => (require(['@/components/model/educationm'], resolve)),
          meta: {
            title: "投资者教育"
          }
        },
        {
          path: "/home_m",
          name: "home_m",
          component: resolve => (require(['@/components/model/homem'], resolve)),
          meta: {
            active: "手机首页"
          }
        },
        {
          path: "/product",
          name: "product",
          component: resolve => (require(['@/components/product'], resolve)),
          meta: {
            active: "产品"
          }
        },
        {
          path: "/product_m",
          name: "product_m",
          component: resolve => (require(['@/components/model/productm'], resolve)),
          meta: {
            active: "产品"
          }
        },
        {
          path: "/privacy",
          name: 'privacy',
          component: resolve => (require(['@/components/privacy'], resolve)),
          meta: {
            active: "隐私政策"
          }
        },
        {
          path: "/privacy_m",
          name: 'privacy_m',
          component: resolve => (require(['@/components/model/privacym'], resolve)),
          meta: {
            active: "隐私政策"
          }
        },
        {
          path: "/join",
          name: "join",
          component: resolve => (require(['@/components/join'], resolve)),
          meta: {
            active: "加入我们"
          }
        },
        {
          path: "/join_m",
          name: "join_m",
          component: resolve => (require(['@/components/model/joinm'], resolve)),
          meta: {
            active: "加入我们"
          }
        },
        {
          path: "/joinUs",
          name: "joinUs",
          component: resolve => (require(['@/components/joinUs'], resolve)),
          meta: {
            active: "招聘"
          }
        },
        {
          path: "/joinUs_m",
          name: "joinUs_m",
          component: resolve => (require(['@/components/model/joinUsm'], resolve)),
          meta: {
            active: "招聘"
          }
        },
        {
          path: "/introduce",
          name: "introduce",
          component: resolve => (require(['@/components/introduce'], resolve)),
          meta: {
            active: "公司介绍"
          }
        },
        {
          path: "/introduce_m",
          name: "introduce_m",
          component: resolve => (require(['@/components/model/introducem'], resolve)),
          meta: {
            active: "公司介绍"
          }
        },
        {
          path: "/server",
          name: 'server',
          component: resolve => (require(['@/components/server'], resolve)),
          meta: {
            active: "服务"
          }
        },
        {
          path: "/info",
          name: 'info',
          component: resolve => (require(['@/components/info'], resolve)),
          meta: {
            active: "文章详情"
          }
        },
        {
          path: "/info_m",
          name: 'info_m',
          component: resolve => (require(['@/components/model/infom'], resolve)),
          meta: {
            active: "文章详情"
          }
        },
        {
          path: "/server_m",
          name: 'server_m',
          component: resolve => (require(['@/components/model/serverm'], resolve)),
          meta: {
            active: "服务"
          }
        },
        {
          path: "/news",
          name: "news",
          component: resolve => (require(['@/components/experience'], resolve)),
          meta: {
            active: "在线体验"
          }
        },
        {
          path: "/news_m",
          name: "news_m",
          component: resolve => (require(['@/components/model/experiencem'], resolve)),
          meta: {
            active: "在线体验"
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js